import { createContext } from 'react'

export type StaticAssetProps =
  Queries.StaticAssetsQuery['staticAssets']['nodes'][0]

export const StaticAssetsContext = createContext<
  Utils.Object<StaticAssetProps>
>({})
